import {Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MatDialog, MatDrawer, MatTabGroup, MatTableDataSource} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import {BaseComponent} from '../BaseComponent';
import {ApiService} from '../api.service';
import {TimeZoneService} from '../../../service/TimeZoneService';
import * as moment from 'moment';
import {CollaboratorsComponent} from './collaborators/collaborators.component';
import {MatDialogRef} from '@angular/material/dialog/typings/dialog-ref';
import {ParseFileVO} from '../exports';
import {AuthService} from '../../../auth/services/auth.service';
import {Vacation} from '../../../model/vacation';
import {ToastrService} from 'ngx-toastr';
import {RequestBodyVacations} from '../InjectionVO';
import {TranslateService} from '@ngx-translate/core';
import {BlockService} from '../../../service/BlockService';
import {UserService} from '../../../service/UserService';
import {DATE_DEFAULT_FORMAT, DATE_TIME_FORMAT} from '../../../model/commons/DateConstants';
import {RoleService} from '../../../service/RoleService';

@Component({
    selector: 'app-masse',
    templateUrl: './masse.component.html',
    styleUrls: ['./masse.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class MasseComponent extends BaseComponent implements OnInit {
    @ViewChild('tabGrp') tabGrp: MatTabGroup;
    displayedColumns = ['users', 'vacations', 'breaks', 'hours', 'motifs', 'actions'];
    dataSource = new MatTableDataSource<any>([]);
    selection = new SelectionModel<any>(true, []);
    users: Array<any> = [];
    siteLinkedUsers: Array<any> = [];
    calendarDays: Array<any> = [];
    isDS :boolean = false;
    _currentday = moment();
    _currentStartWeek = this.getStartOfWeekByDate();
    isloading: boolean = true;
    isNotSelectAll: boolean = false;
    responseRows: ParseFileVO = {
        prepareRowsError: [],
        blocks: [], parseRows: [], rows: [], rowsIndexError: [], rowsError: [], indexRows: []
    };
    private timeZone: number = 0;
    dataRealiseAllInjection: any[] = [];
    isSelected: boolean = false;

    @ViewChild('drawerValidation') drawer: MatDrawer;

    @ViewChild('drawerValidation') sideNav: ElementRef;

    injectionOverlappedExist: boolean = false;
    saveInjectionOverlapped: boolean = false;
    allRowsFailed: boolean = false;
    rowsIndexError: any[] = [];
    rowsErrorCount : number = 0;

    constructor(private toastrService: ToastrService, private api: ApiService, public tz: TimeZoneService, private dialog: MatDialog, private user: AuthService, private translate: TranslateService,
                public blockservice: BlockService, private userService: UserService, private roleService: RoleService
    ) {
        super();
      translate.onLangChange.subscribe(() => {
        this.validatorsCollaborators(this.dataRealiseAllInjection,true);
      })
    }

    get timeZoneLabel() {
        const {payload} = this.tz;
        const {city} = payload;
        let padZero = (v: number) => {
            v = v < 0 ? v * -1 : v;
            return (v < 10 ? '0' + v : (v)) + ':00';
        };
        let tz: any = this.timeZone;
        return (tz > -1 ? '' : '-') + padZero(this.timeZone);
    }

    get getDays() {
        const start = moment(this._currentStartWeek).startOf('isoWeeks');
        const end = moment(this._currentStartWeek).endOf('isoWeeks');
        //console.log("getDays:", {day: this._currentStartWeek, start: start.format("YYYY-MM-DD"), end:
        // end.format("YYYY-MM-DD")})
        return this.calendarDays.filter((day) => {
            return moment(day.date).isBetween(start, end, 'isoWeeks', '[]');
        });
    }

    get currentDay(): {
        users: Array<any>,
        date: any,
        day: any,
        name: any,
        isNow: boolean,
        isSelected: boolean,
        isDisabled: boolean
    } {
        console.log('currentDay ...');
        return this.calendarDays.find((day: any) => (
            moment(day.date).format('YYYY-MM-DD') ==
            moment(this._currentday).format('YYYY-MM-DD')
        ));
    }

    get total() {
        return this.calendarDays.map((e) => e.users.length).reduce((p, c) => p + c, 0);
    }

    get totalRows() {
        const sheet = this.responseRows;
        const values = this.groupRows(sheet.rows).asValues;
        return values.length;
    }

    get blocks() {
        const blocks: any[] = this.responseRows.blocks;
        return blocks.filter((b: any) => b.date == moment(this._currentday).format('YYYY-MM-DD'));
    }

    get lengthSelected() {
      const {blocks} = this.responseRows || {blocks: []};
      let rowErrorIndex = this.rowsIndexError.filter(r=> r.messageError).map(r=> r.index);
      return (blocks || []).filter((e) => e.selected).filter(b=> !rowErrorIndex.includes(b.index)).length;
    }

    loading = false;

    async ngOnInit() {
        this.isloading = true;
        this.isDS = this.roleService.isDS;
        const username = this.user.getUser('username');
        this.tz.setUser(username);
        this.users = await this.api.getCollaborators();
        this.siteLinkedUsers = await this.api.getCollaboratorsDirSite();
        this.isloading = false;
        console.log('user:', this.users);
        console.log('siteLinkedUsers:', this.siteLinkedUsers);
        this.calendarDays = this.getCurrentWeek(this._currentStartWeek, 'users', []);
        console.log(this.calendarDays);
    }

    /** Switch Tabs by event*/
    selectIndexTab(index: any) {
        this.tabGrp.selectedIndex = index;
    }

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    isAllSelectedV2() {
      let rowErrorIndex = this.rowsIndexError.filter(r=> r.messageError).map(r=> r.index);
      return this.responseRows && this.responseRows.blocks &&
            this.responseRows.blocks.filter(b=> !rowErrorIndex.includes(b.index)).length === this.responseRows.blocks.filter(b=> !rowErrorIndex.includes(b.index)).filter(r => r.selected).length;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected() ?
            this.selection.clear() :
            this.dataSource.data.forEach(row => this.selection.select(row));
    }

    checkValidaty(rows, index, hour: string, key: string) {
        return this.checkRowsValues(rows, index, hour, key);
    }

    setHourOfVacation(rows, key, value, event) {
        this.setHour(rows, key, value, event);
    }

    toWeek(action) {
        let date = this._currentStartWeek;
        if (action == 'next') {
            date = moment(this._currentStartWeek).add(1, 'weeks');
        } else {
            date = moment(this._currentStartWeek).subtract(1, 'weeks');
        }

        this._currentStartWeek = date.startOf('isoWeeks');
        if (this.getDays.length == 0) {
            this.calendarDays = this.calendarDays.concat(this.getCurrentWeek(this._currentStartWeek, 'users', []));
        }
    }

    getStartOfWeekByDate(date?: any): any {
        return moment(date || new Date()).startOf('isoWeeks');
    }

    setDay(day) {
        this._currentStartWeek;
        this.calendarDays.map((e) => {
            e.isNow = false;
            e.isSelected = false;
            return e;
        });
        day.isSelected = true;
        this._currentday = moment(day.date);
        if (day.users) {
            this.dataSource.data = day.users;
        }
    }

    openDialogUser() {
        const result: MatDialogRef<CollaboratorsComponent> = this.dialog.open(CollaboratorsComponent, {
            data: {
                usersSelected: this.currentDay.users.map(e => e.username),
                date: this._currentday,
            },
            //disableClose: true
        });
        result.afterClosed().subscribe((users: Array<any>) => {
            if (users) {
                users = users.map((user) => {
                    return this.mapUserRow(user);
                });
                //console.log(data)
                this.currentDay.users = this.currentDay.users.concat(users);
                this.dataSource.data = this.currentDay.users;
            }
        });
    }

    mapUserRow(user) {
        return {
            ...user,
            vacations: [{start1: null, end1: null, start2: null, end2: null}],
            breaks: [{start1: null, end1: null, start2: null, end2: null}],
        };
    }

    rmRow(element: any) {
        this.currentDay.users = this.currentDay.users.filter((user) => {
            return user.username != element.username;
        });
        this.dataSource.data = this.currentDay.users;
    }

    loadFiles(event) {
        const [file] = event.target.files;
        if (file) {
            this.readerFile(file, (data: any) => {
                data = data.SheetNames.map((name) => data.Sheets[name]).flat();
                this.responseRows = this.parseValueFile(data);
                this.loadRealiseAllBlock(this.responseRows)
                    .subscribe((res: any) => {
                        this.validatorsCollaborators(res);
                        this.dataRealiseAllInjection = res;
                        this.responseRows.rowsError = this.responseRows.rowsIndexError.map((index) => {
                            return this.responseRows.rows.filter(row => row.i == index);
                        });
                        this.responseRows.blocks = this.rowsToBlocks();
                        this.fetchRealized(this.responseRows.blocks);
                        if(this.responseRows.blocks && this.responseRows.blocks.length == this.rowsIndexError.filter(r=> r.messageError).length)
                        {
                          this.allRowsFailed = true;
                          this.isNotSelectAll = true;
                          this.downloadFileWithFailedInjections(true);
                        }
                    });
                event.target.value = '';
            });
        }
    }

    validatorsCollaborators(dataRealise, changeLang?) {
        this.rowsIndexError = [];
        this.rowsErrorCount = 0;
        const sheet = this.responseRows;
        const values = this.groupRows(sheet.rows).asValues;
        const translate = this.translate.translations[this.translate.currentLang];
      values.map((row, i) => {
            const rowIndex = row[0].i;
            const username = row.find(e => e.col == 'A').value;
            const date = row.find(e => e.col == 'B').value;
            const message = "";

            // check in hierarchy
            const user = this.users.find((user) => user.username == this.padUserName(user.username, username));
            const userLinkedSite = this.siteLinkedUsers.find((user) => user.username == this.padUserName(user.username, username));


            if (!user) {
                row.find(e => e.col == 'A').error = true;
                row.find(e => e.col == 'A').message = "";
                row.find(e => e.col == 'A').message = (message ? message + ',' : '') + translate.INJECTION['USER_NOT_IN_COMPO'];
                row.find(e => e.col == 'A').match = false;
                //this.responseRows.rowsIndexError.push(rowIndex);
                this.rowsErrorCount = this.rowsErrorCount + 1;
                this.rowsIndexError.push({index: rowIndex, message: "", messageError: (message ? message + ',' : '') + translate.INJECTION['USER_NOT_IN_COMPO']});
            } else {
                if (dataRealise) {
                    let vacations = this.rowXlsxToInjection(row);
                    const allBlockRealiseOfBInjected = dataRealise
                        .filter(blockRealized => blockRealized && blockRealized.user && blockRealized.user.username == user.username && moment(date).isSameOrAfter(moment(blockRealized.start).format(DATE_DEFAULT_FORMAT)));
                    allBlockRealiseOfBInjected.sort((b, a) => new Date(b.start).getTime() - new Date(a.start).getTime());
                    let isOverlapped = this.isTotallyOverlappedWithRealized(allBlockRealiseOfBInjected, vacations, date);
                    if (isOverlapped) {
                        row.find(e => e.col == 'A').error = true;
                        row.find(e => e.col == 'A').message = "";
                        row.find(e => e.col == 'A').message = (message ? message + ',' : '') + isOverlapped == 'totally_overlaps' ? translate.INJECTION['TOTALLY_OVERLAPS'] : translate.INJECTION['PARTIAL_OVERLAPS'];
                        row.find(e => e.col == 'A').match = false;
                        row.find(e => e.col == 'A').overlapped = isOverlapped;
                        this.responseRows.rowsIndexError.push(rowIndex);
                        this.rowsIndexError.push({index: rowIndex, message: isOverlapped,messageError:""});
                        this.injectionOverlappedExist = true;
                    }
                }
                console.log('IN PERIODS TEAM:', date, user.periods);
                console.log('IN PERIODS SITE:', date, userLinkedSite);
                if (this.checkInPeriods(date,user,userLinkedSite)) {
                    row.find(e => e.col == 'A').error = true;
                    row.find(e => e.col == 'A').message = "";
                    row.find(e => e.col == 'A').message = (message ? message + ',' : '') + translate.INJECTION['USER_NOT_IN_PERIODS'];
                    row.find(e => e.col == 'A').match = false;
                    //this.responseRows.rowsIndexError.push(rowIndex);
                    this.rowsErrorCount = this.rowsErrorCount + 1;
                    this.rowsIndexError.push({index: rowIndex, message: "", messageError : (message ? message + ',' : '') + translate.INJECTION['USER_NOT_IN_PERIODS']});
                }
                if (!this.InPeriodsInjection(date)) {
                    row.find(e => e.col == 'B').error = true;
                    row.find(e => e.col == 'B').message = (message ? message + ',' : '') + translate.INJECTION['USER_NOT_IN_PERIODS_PAIE'];
                    row.find(e => e.col == 'B').match = false;
                    //this.responseRows.rowsIndexError.push(rowIndex);
                    this.rowsErrorCount = this.rowsErrorCount + 1;
                    this.rowsIndexError.push({index: rowIndex, message: "" , messageError:(message ? message + ',' : '') + translate.INJECTION['USER_NOT_IN_PERIODS_PAIE']});
                }
            }

        });


        let rowsIndexError = this.responseRows.rowsIndexError.map((index) => {
            return this.responseRows.rows.filter(row => row.i == index);
        });
        this.loading = true;
        this.responseRows.rowsError = rowsIndexError;
        this.responseRows.prepareRowsError = rowsIndexError;
      //if(this.rowsIndexError.length == 1 && this.rowsIndexError[0].messageError)
        //this.downloadFileWithFailedInjections(true);
    }


    async fetchRealized(rows: Array<any>) {
        const payload = rows.filter(r=> r.user).map((r) => ({
            matricule: r.user.username,
            motif: r.motif,
            date: r.date
        }));
        const rest = await this.api.fetchBlocks(payload);
        this.responseRows.blocks = this.rowsToBlocks(rest);
    }

    getRows(key, index) {
        console.log('key, index :', key, index);
        return this.responseRows.rows.filter(e => e.i == index && e.col == key);
    }

    rowsToBlocks(data?: Array<any>) {
        return this.rowsXlsxToJson(this.responseRows).map(row => {
            const {
                username,
                date,
                vacation1,
                vacation2,
                vacation3,
                vacation4,
                break1,
                break2,
                breaks,
                motif,
                rowIndex
            } = row;
            const dates: any = this.mapVacationMock(row, true, true);
            const user = this.users.find((user) => user.username == this.padUserName(user.username, username));

            let fiche = null;
            let mocks: any = this.mapVacationMock(row, false);

            if (data) {
                fiche = data.find(e => e.matricule == user && user.username && e.date == date);
                console.log('fiche:', fiche);
                if (fiche) {
                    mocks = (fiche.blocks || []).map((block) => {
                        const start = moment(block.start).format(DATE_TIME_FORMAT);
                        const end = moment(block.end).format(DATE_TIME_FORMAT);
                        dates.push(start);
                        dates.push(end);
                        return {
                            start,
                            end,
                            color: '#99eca7',
                            data: {
                                label: 'test'
                            }
                        };
                    });
                } else {
                    mocks = [];
                }
            }
            const iEnd = new Date(Math.max(...dates.map(e => new Date(e))));
            const iStart = new Date(Math.min(...dates.map(e => new Date(e))));

            return {
                fiche,
                avis: fiche ? fiche.avisSystem ? 'AVIS_SUCCESS' : 'AVIS_ERROR' : null,
                vacations: {vacation1, vacation2, vacation3, vacation4},
                breaks: {break1, break2},
                motif,
                user,
                username,
                index: rowIndex,
                date,
                interval: {
                    start: moment(iStart).subtract(1, 'hours').format(DATE_TIME_FORMAT),
                    end: moment(iEnd).add(1, 'hours').format(DATE_TIME_FORMAT)
                },
                data: [{
                    label: 'REALISE',
                    blocks: mocks
                },
                    {
                        label: 'INJECTION',
                        eventchip: true,
                        blocks: this.mapVacationMock(row, true)

                    }]
            };
        });
    }

    reset() {
        this.file = null;
        this.responseRows = {
            prepareRowsError: [],
            parseRows: [], rows: [], rowsIndexError: [], rowsError: [], indexRows: []
        };
        this.saveInjectionOverlapped = false;
        this.injectionOverlappedExist = false;
        this.isNotSelectAll = false;
        this.isSelected = false;
        this.allRowsFailed = false;
    }

    collapsed(value) {
        this.responseRows.blocks.forEach((e) => {
            e['collapsed'] = value;
        });
    }

    selectRow(row: any, ev: any) {
        setTimeout(() => {
            row.selected = ev.checked;
        }, 2e2);
    }

    /*  save() {
        let isRealise = this.checkIfAnyRealiseBlockAlreadyExist();
        if (isRealise || indexInjectionBlocked) {
          this.drawer.open();
          this.drawer.opened = true;
          this.visibleDrawerValidationInjection = true;
        } else {
          this.saveData();
          this.drawer.opened = false;
          this.visibleDrawerValidationInjection = false;
        }
      }*/

  _send : boolean = false;
    save() {
      this._send = true;
      let rowErrorIndex = this.rowsIndexError.filter(r=> r.messageError).map(r=> r.index);
        const payload: any = this.responseRows.blocks.filter(b=> !rowErrorIndex.includes(b.index)).filter((e: any) => e.selected).map(e => {
            const {user, vacations, breaks, motif, date, index} = e;
            const {username, firstName, lastName} = user;
            const injectionIsOverlapped = this.rowsIndexError.filter(r => r.index == index && r.message);
            const stateInjection = injectionIsOverlapped.length > 0 ? injectionIsOverlapped[0].message : '';
            return {
                date,
                timezone: this.tz.tz,
                matricule: username,
                injectionAction: 'add',
                fullName: [firstName, lastName].join(' '),
                forceSiFormation: false,
                vacationAndPausesVo: {
                    vacations: this.mapVacation(vacations, date),
                    pauses: this.mapPause(breaks, date)
                },
                pause: null,
                other: !this.checkIsOtherMotif(motif),
                etat: this.getStatInjection(stateInjection),
                motif: this.getMotif(motif)
            };
        });

        this.api.saveVacations(payload).then((res) => {
            if (res.injected > 0 && res.notInjected > 0) {
                this.toastrService.warning('Erreur : ' + res.notValidItems[0].failedReasons[0], 'les matricules suivants ne sont pas injectés ' + this.getNotValidItems(res.notValidItems), {
                    enableHtml: true
                });
            } else if (res.injected > 0 && res.notInjected <= 0) {
                if (this.isAllSelectedV2() || this.responseRows.blocks.length == 1)
                {
                  this.isNotSelectAll = true;
                    if (this.rowsIndexError.filter(e=> e.messageError).length > 0)
                        this.downloadFileWithFailedInjections();
                    //this.responseRows.blocks = [];
                }
                else {
                  this.responseRows.blocks = this.responseRows.blocks.filter(b=> !b.selected);
                  this.toastrService.success('L\'opération a été bien effectuée', 'Message Success!');
                }
            } else {
                this.isNotSelectAll = true;
                if (this.rowsIndexError.filter(e=> e.messageError).length > 0)
                    this.downloadFileWithFailedInjections();
            }
          this._send = false;
        });
    }

    downloadFile() {
        // Check user language to set the file language
        const lang = this.translate.currentLang;
        if (lang === 'fr') {
            const header = ['Matricule', 'Date Présence(DD/MM/YYYY)', 'Début Vacation 1 (HH:mm)', 'Fin Vacation 1 (HH:mm)'
                , 'Début Vacation 2 (HH:mm)', 'Fin Vacation 2 (HH:mm)', 'Début Vacation 3 (HH:mm)', 'Fin Vacation 3 (HH:mm)',
                'Début Vacation 4 (HH:mm)', 'Fin Vacation 4 (HH:mm)', 'Début Pause 1 (HH:mm)', 'Fin Pause 1 (HH:mm)',
                'Début Pause 2 (HH:mm)', 'Fin Pause 2 (HH:mm)', 'Motif de la demande'];
            this.api.generateExcel(header, 'Injections_template');
        } else if (lang === 'en') {
            const header2 = ['Registration Number', 'Presence Date(DD/MM/YYYY)', 'Start Vacation 1 (HH:mm)', 'End' +
            ' Vacation 1 (HH:mm)', 'Start Vacation 2 (HH:mm)', 'End Vacation 2 (HH:mm)', 'Start Vacation 3 (HH:mm)', 'End' +
            ' Vacation 3 (HH:mm)', 'Start Vacation 4 (HH:mm)', 'End Vacation 4 (HH:mm)', 'Start Break 1 (HH:mm)', 'End Break 1' +
            ' (HH:mm)', 'Start Break 2 (HH:mm)', 'End Break 2 (HH:mm)', 'Request Reason'];
            this.api.generateExcel(header2, 'Injections_template');
        }
    }

    private mapVacation(vacations: any, date: any) {
        let vacationResult: Vacation[] = [];
        const {vacation1, vacation2, vacation3, vacation4} = vacations;

        vacationResult.push({
            debut: `${date} ${vacation1.start}`,
            fin: `${date} ${vacation1.end}`,
        });
        if (vacation2.start && vacation2.end) {
            vacationResult.push({
                debut: `${date} ${vacation2.start}`,
                fin: `${date} ${vacation2.end}`,
            });
        }

        if (vacation3.start && vacation3.end) {
            vacationResult.push({
                debut: `${date} ${vacation3.start}`,
                fin: `${date} ${vacation3.end}`,
            });
        }

        if (vacation4.start && vacation4.end) {
            vacationResult.push({
                debut: `${date} ${vacation4.start}`,
                fin: `${date} ${vacation4.end}`,
            });
        }
        return vacationResult;
    }

    private mapPause(breaks: any, date: any) {
        let breaksResult: Vacation[] = [];
        const {break1, break2} = breaks;
        if (break1.start && break1.end) {
            breaksResult.push({
                debut: `${date} ${break1.start}`,
                fin: `${date} ${break1.end}`,
            });
        }

        if (break2.start && break2.end) {
            breaksResult.push({
                debut: `${date} ${break2.start}`,
                fin: `${date} ${break2.end}`,
            });
        }


        return breaksResult;
    }

    private mapVacationMock(row: {
        date: any;
        break1: { start: any; end: any };
        break2: { start: any; end: any };
        vacation1: { start: any; end: any };
        breaks: number;
        vacation2: { start: any; end: any };
        vacation3: { start: any; end: any };
        vacation4: { start: any; end: any };
        rowIndex: any;
        motif: any;
        username: any
    }, isMock: boolean, isDates?: boolean) {

        const {date, vacation1, vacation2, vacation3, vacation4} = row;

        const [s1, e1] = [vacation1.start, vacation1.end];
        const [s2, e2] = [vacation2.start, vacation2.end];
        const [s3, e3] = [vacation3.start, vacation3.end];
        const [s4, e4] = [vacation4.start, vacation4.end];
        let mocks: any = [];
        let dates: any = [];
        if (s1 && e1) {
            if (isMock) {
                mocks.push({
                    start: `${date} ${s1}`,
                    end: `${date} ${e1}`,
                    color: '#99eca7'
                });
            } else {
                mocks.push({
                    start: `${date} ${s1}`,
                    end: `${date} ${e1}`,
                    color: '#eee',
                    placeholder: true
                });
            }
            dates.push(`${date} ${s1}`);
            dates.push(`${date} ${e1}`);
        }
        if (s2 && e2) {
            if (isMock) {
                mocks.push({
                    start: `${date} ${s2}`,
                    end: `${date} ${e2}`,
                    color: '#99eca7'
                });
            } else {
                mocks.push({
                    start: `${date} ${s2}`,
                    end: `${date} ${e2}`,
                    color: '#eee',
                    placeholder: true
                });
            }
            dates.push(`${date} ${s2}`);
            dates.push(`${date} ${e2}`);
        }
        if (s3 && e3) {
            if (isMock) {
                mocks.push({
                    start: `${date} ${s3}`,
                    end: `${date} ${e3}`,
                    color: '#99eca7'
                });
            } else {
                mocks.push({
                    start: `${date} ${s3}`,
                    end: `${date} ${e3}`,
                    color: '#eee',
                    placeholder: true
                });
            }

            dates.push(`${date} ${s3}`);
            dates.push(`${date} ${e3}`);

        }
        if (s4 && e4) {
            if (isMock) {
                mocks.push({
                    start: `${date} ${s4}`,
                    end: `${date} ${e4}`,
                    color: '#99eca7'
                });
            } else {
                mocks.push({
                    start: `${date} ${s4}`,
                    end: `${date} ${e4}`,
                    color: '#eee',
                    placeholder: true
                });
            }
            dates.push(`${date} ${s4}`);
            dates.push(`${date} ${e4}`);

        }

        return isDates ? dates : mocks;
    }

    private getNotValidItems(notValidItems: RequestBodyVacations[]) {
        //res.notValidItems[0].failedReasons[0]
        return notValidItems.map(item => ' matricule : ' + item.matricule + ' - ' + ' date : ' + item.date);
    }

    get checkIsTotalOverlapped() {
        return this.rowsIndexError.filter(r => r.message == 'totally_overlaps').length > 0;
    }

    selectAllInjection() {
        this.isSelected = !this.isSelected;
        if (this.isAllSelectedV2())
          this.isSelected = false;
        if (this.isSelected) {
            this.responseRows.blocks.forEach(row => row.selected = true);
        } else {
            this.responseRows.blocks.forEach(row => row.selected = false);
        }

    }

    InPeriodsInjection(dateFiche): boolean {
        const country = this.userService.getUserCountry();
        /** check country if MADA or MAURICE */
        if (['MU', 'MG'].includes(country)) {
            const dates = this.tz.getReopenFichePeriod(1, 1, 0, moment(dateFiche), country);
            return moment(dateFiche).isSameOrBefore(moment(dates[1])) && moment(dateFiche).isSameOrAfter(moment(dates[0]));
        }

        return true;
    }


    private loadAllBlockRealizedByUsernameDate(dates: any[]) {
        this.dataRealiseAllInjection = [];
        this.blockservice.loadBlockRealizedByDateMatricule(dates).subscribe((res: any) => {
            this.dataRealiseAllInjection = res;
        });
    }

    private checkIfAnyRealiseBlockAlreadyExist(): boolean {
        const blocksDateUsername = this.responseRows.blocks.filter((e: any) => e.selected).map(function (d) {
            return {username: d.user ? d.user.username : '', date: d.date};
        });
        let isRealiseExist = false;
        blocksDateUsername.forEach(b => {
            isRealiseExist = this.checkIfRealiseExist(b);
            if (isRealiseExist) {
                return isRealiseExist;
            }
        });

        return isRealiseExist;
    }

    private checkIfRealiseExist(b: { date: any; username: any }) {
        let list = this.dataRealiseAllInjection.filter(block =>
            block && block.user && block.user.username == b.username &&
            moment(b.date).isSameOrAfter(moment(block.start).format(DATE_DEFAULT_FORMAT)));


        return list.length > 0;
    }

    closeDrawer() {
        this.drawer.close();
    }

    private loadRealiseAllBlock(responseRows) {
        const sheet = responseRows;
        let blocks = [];
        const values = this.groupRows(sheet.rows).asValues;
        values.map((row, i) => {
            const date = row.find(e => e.col == 'B').value;
            const username = row.find(e => e.col == 'A').value;
            const user = this.users.find((user) => user.username == this.padUserName(user.username, username));
            if (user) {
                blocks.push({username: user.username, date: date});
            }

        });
        return this.blockservice.loadBlockRealizedByDateMatricule(blocks);

    }


    private isTotallyOverlappedWithRealized(blocksRealise, vacations, date) {
        let blockRealiseEmpty: any[] = [];
        let isOverlapped: string = null;
        blockRealiseEmpty = [];
        blocksRealise.sort((b, a) => new Date(b.start).getTime() - new Date(a.start).getTime());
        blocksRealise.forEach((block, index) => {
            if (index == 0 || index == blocksRealise.length - 1) {
                let start = moment(block.start).utcOffset(0);
                let end = moment(block.start).utcOffset(0);
                if (index == 0) {
                    start.set({hour: 0, minute: 0, second: 0, millisecond: 0});
                    blockRealiseEmpty.push({
                        start: moment(start).format(DATE_TIME_FORMAT),
                        end: moment(block.start).format(DATE_TIME_FORMAT)
                    });
                }
                if (index == blocksRealise.length - 1) {
                    end.set({hour: 23, minute: 59, second: 0, millisecond: 0});
                    blockRealiseEmpty.push({
                        start: moment(blocksRealise[index].end).format(DATE_TIME_FORMAT),
                        end: moment(end).format(DATE_TIME_FORMAT)
                    });
                }
            }
            if (index > 0) {
                if (!moment(block.start).isSame(moment(blocksRealise[index - 1].end))) {
                    blockRealiseEmpty.push({
                        start: moment(blocksRealise[index - 1].end).format(DATE_TIME_FORMAT),
                        end: moment(block.start).format(DATE_TIME_FORMAT)
                    });
                }
            }
        });

        let i = 0;
        blockRealiseEmpty.forEach(block => {
            if (this.checkVacationInBlockRealiseEmpty(block, vacations, date)) {
                i++;
                return;
            }
        });
        if (i == 0 && blocksRealise && blocksRealise.length > 0) {
            isOverlapped = 'totally_overlaps';
            console.log('fiche bloquant ', date + 'start vacation->' + vacations.vacation1.start);
        } else if (blocksRealise && blocksRealise.length > 0) {
            isOverlapped = 'partial_overlap';
            console.log('fiche non bloquant ', date + 'start vacation->' + vacations.vacation1.start);
        }


        return isOverlapped;
    }

    private checkVacationInBlockRealiseEmpty(block: any, vacations: any, date) {
        const formatVacation = (d, h) => moment(`${d} ${h}`);
        let isBlcoked = (vacations.vacation1.start && (formatVacation(date, vacations.vacation1.start).isBetween(moment(block.start), moment(block.end)))) ||
            (vacations.vacation1.end && (formatVacation(date, vacations.vacation1.end).isBetween(moment(block.start), moment(block.end)))) ||
            (vacations.vacation2.start && (formatVacation(date, vacations.vacation2.start).isBetween(moment(block.start), moment(block.end)))) ||
            (vacations.vacation2.end && (formatVacation(date, vacations.vacation2.end).isBetween(moment(block.start), moment(block.end)))) ||
            (vacations.vacation3.start && (formatVacation(date, vacations.vacation3.start).isBetween(moment(block.start), moment(block.end)))) ||
            (vacations.vacation3.end && (formatVacation(date, vacations.vacation3.end).isBetween(moment(block.start), moment(block.end)))) ||
            (vacations.vacation4.start && (formatVacation(date, vacations.vacation4.start).isBetween(moment(block.start), moment(block.end)))) ||
            (vacations.vacation4.end && (formatVacation(date, vacations.vacation4.end).isBetween(moment(block.start), moment(block.end))));

        return isBlcoked;
    }

    getRow(row: any): any {
        const translate = this.translate.translations[this.translate.currentLang];
        row.data.forEach((d, index) => {
            d.label = index == 0 ? translate.INJECTION['REALISE'] : translate.INJECTION['INJECTION'];
        });

        return row;

    }

    getData() {
        console.log('rowsIndexError : ', this.responseRows.rowsIndexError);
        return this.rowsIndexError.filter(r=> !r.messageError).map(i=> i.index);
    }


    private rowXlsxToInjection(row: any) {
        const s1 = row.find(e => e.col == 'C').value;
        const e1 = row.find(e => e.col == 'D').value;
        const s2 = row.find(e => e.col == 'E').value;
        const e2 = row.find(e => e.col == 'F').value;
        const s3 = row.find(e => e.col == 'G').value;
        const e3 = row.find(e => e.col == 'H').value;
        const s4 = row.find(e => e.col == 'I').value;
        const e4 = row.find(e => e.col == 'J').value;
        return {
            vacation1: {start: s1, end: e1},
            vacation2: {start: s2, end: e2},
            vacation3: {start: s3, end: e3},
            vacation4: {start: s4, end: e4}
        };
    }

    acceptSaveInjectionOverlapped() {
        this.saveInjectionOverlapped = true;
        this.responseRows.rowsError = [];
    }

    getBlocks() {
        return this.responseRows.blocks;
    }

    private getStatInjection(stateInjection) {
        if (!stateInjection) {
            return 0;
        }
        return stateInjection == "totally_overlaps" ? 2 : 1;

    }

    checkIsTotalOverlappedAndIsNotBlockedInjection() {
      return this.injectionOverlappedExist && !this.saveInjectionOverlapped && this.rowsIndexError.length && this.rowsIndexError.filter(e=> e.message).length > 0;
    }

  private checkInPeriods(date: any, user: any, userLinkedSite: any) {
    if (this.isDS)
      return !(this.InPeriods(date, user.periods) || this.InPeriods(date, userLinkedSite.periods));
    return !this.InPeriods(date, user.periods);
  }

    downloadFileWithFailedInjections(reset?){
      let header = this.getHeaderFile();
      let data = this.mapDataRowsError();
      this.api.generateExcelFailedInjections(header,data, 'Injections_failed');

  }

    getHeaderFile(){
        const lang = this.translate.currentLang;
        return lang === 'fr'?['Matricule', 'Date Présence(DD/MM/YYYY)', 'Début Vacation 1 (HH:mm)', 'Fin Vacation 1 (HH:mm)'
            , 'Début Vacation 2 (HH:mm)', 'Fin Vacation 2 (HH:mm)', 'Début Vacation 3 (HH:mm)', 'Fin Vacation 3 (HH:mm)',
            'Début Vacation 4 (HH:mm)', 'Fin Vacation 4 (HH:mm)', 'Début Pause 1 (HH:mm)', 'Fin Pause 1 (HH:mm)',
            'Début Pause 2 (HH:mm)', 'Fin Pause 2 (HH:mm)', 'Motif de la demande', 'Erreur']:
            ['Registration Number', 'Presence Date(DD/MM/YYYY)', 'Start Vacation 1 (HH:mm)', 'End' +
            ' Vacation 1 (HH:mm)', 'Start Vacation 2 (HH:mm)', 'End Vacation 2 (HH:mm)', 'Start Vacation 3 (HH:mm)', 'End' +
            ' Vacation 3 (HH:mm)', 'Start Vacation 4 (HH:mm)', 'End Vacation 4 (HH:mm)', 'Start Break 1 (HH:mm)', 'End Break 1' +
            ' (HH:mm)', 'Start Break 2 (HH:mm)', 'End Break 2 (HH:mm)', 'Request Reason', 'Error'];
    }

    private mapDataRowsError() {
      let data : any [] = [];
      let rowErrorIndex = this.rowsIndexError.filter(r=> r.messageError).map(r=> r.index);
      let rowsError = this.responseRows.blocks.filter(b=> rowErrorIndex.includes(b.index));

      rowsError.forEach(row=> {
        let rowData: string[] = [row.username, row.date, row.vacations.vacation1.start,row.vacations.vacation1.end,
          row.vacations.vacation2.start,row.vacations.vacation2.end,row.vacations.vacation3.start,
          row.vacations.vacation3.end,row.vacations.vacation4.start,row.vacations.vacation4.end,
          row.breaks.break1.start,row.breaks.break1.end,row.breaks.break2.start,
          row.breaks.break2.end,row.motif,this.rowsIndexError.filter(r=> r.index == row.index)[0].messageError];
        data.push(rowData);
      })
      return data;
    }

  checkIfBlockInjectionList() {
      let rowErrorIndex = this.rowsIndexError.filter(r=> r.messageError).map(r=> r.index);
    return this.responseRows.blocks &&
      this.responseRows.blocks.filter(b=> !rowErrorIndex.includes(b.index)).length > 1 &&
      this.responseRows.rowsError.length == 0
  }

  private checkIsOtherMotif(motif: any) {
    return motif && ('absence du realise' == motif.toLowerCase() || 'absence du réalisé' == motif.toLowerCase() ||
      'incident mytime' == motif.toLowerCase() || 'absence_realise' == motif.toLowerCase() || 'absence_realise' == motif.toLowerCase() || 'incident_mytime' == motif.toLowerCase());
  }

  private getMotif(motif: any) {
    if (this.checkIsOtherMotif(motif))
      return ["realise","absence"].includes(motif.toLowerCase()) ?"ABSENCE_REALISE" : "INCIDENT_MYTIME"
    return motif;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/injection/masse/masse.component.ts